const fragment = `
  id
  imageUrl
  isDefault
`;

export const listBuildingModelImagesQuery = `
  query ListBuildingModelImages(
    $filter: BuildingModelImageFilterInput
  ) {
    items: listBuildingModelImages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createBuildingModelImageQuery = `
  mutation CreateBuildingModelImage(
    $input: CreateBuildingModelImageInput!
    $image: Upload
  ) {
    item: createBuildingModelImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateBuildingModelImageQuery = `
  mutation UpdateBuildingModelImage(
    $input: UpdateBuildingModelImageInput!
    $image: Upload
  ) {
    item: updateBuildingModelImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteBuildingModelImageQuery = `
  mutation DeleteBuildingModelImage(
    $id: Int!
  ) {
    item: deleteBuildingModelImage(id: $id) {
      ${fragment}
    }
  }
`;

export const sortBuildingModelImagesQuery = `
  mutation SortBuildingModelImages(
    $buildingModelId: Int!,
    $ids: [Int!]!
  ) {
    items: sortBuildingModelImages(buildingModelId: $buildingModelId, ids: $ids) {
      id
    }
  }
`;
